import React, { useState,useEffect } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  Nav,
  Button,
  Form,
  Table,
  Badge,
  ProgressBar,
} from "react-bootstrap";
import { fetchOrders, fetchCustomerAddress,getCustomerFromStorage } from "../api/apiService";
import { useCartContext } from "../context/CartContext";

// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const AccountDashboard = () => {
  const [activeTab, setActiveTab] = useState("dashboard");

  const ordersss = [
    {
      id: "#JC1001",
      product: "Diamond Ring",
      amount: "₹25,000",
      status: "Delivered",
    },
    {
      id: "#JC1002",
      product: "Gold Necklace",
      amount: "₹42,000",
      status: "Processing",
    },
  ];

  const wishlist = [
    {
      id: 1,
      name: "Gold Ring",
      price: "₹18,999",
      image: "https://via.placeholder.com/300x250",
    },
    {
      id: 2,
      name: "Diamond Pendant",
      price: "₹24,999",
      image: "https://via.placeholder.com/300x250",
    },
  ];

  
const [customer, setCustomer] = useState(null);
const [orders, setOrders] = useState([]);
const [addresses, setAddresses] = useState([]);

  const user = getCustomerFromStorage();
  const customer_id = user?.id;
  const session = JSON.parse(localStorage.getItem("session"));

  const [formData, setFormData] = useState({
  first_name: "",
  email: "",
  telephone: "",
  birthday: "",
  anniversary: ""
});
  // =========================
  // GET CUSTOMER DATA
  // =========================
  useEffect(() => {
    const loadData = async () => {
      try {
        if (!customer_id) return;

   
         const ordersRes = await fetchOrders({customer_id});
         const addressRes = await fetchCustomerAddress({customer_id});

        if(ordersRes.success==true){
           setOrders(ordersRes.data || []);

        }
         if(addressRes.success==true){
           setAddresses(addressRes.data || []);

        }
      } catch (err) {
        console.log(err.message);
      }
    };

    loadData();
  }, [customer_id]);

useEffect(() => {
const user = JSON.parse(localStorage.getItem("session"));
if (user) {
  setFormData({
    first_name: user.first_name || "",
    
    email: user.email || "",
    telephone: user.telephone || "",
    birthday: user.birthday || "",
    anniversary: user.anniversary || ""
  });
}
}, []);
 // handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const renderContent = () => {
    switch (activeTab) {
      case "dashboard":
        return (
          <>
            <h4 className="mb-4">Welcome Back 👋</h4>

            <Row className="g-3 mb-4 text-black">
              <Col md={3}>
                <Card className="shadow-sm border-0">
                  <Card.Body>
                    <h3>{orders.length?orders.length:"0"}</h3>
                    <small>Orders</small>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={3}>
                <Card className="shadow-sm border-0">
                  <Card.Body>
                    <h3>8</h3>
                    <small>Wishlist</small>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={3}>
                <Card className="shadow-sm border-0">
                  <Card.Body>
                    <h3>1500</h3>
                    <small>Reward Points</small>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={3}>
                <Card className="shadow-sm border-0">
                  <Card.Body>
                    <h3>3</h3>
                    <small>Addresses</small>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Card className="border-0 shadow-sm">
              <Card.Body>
                <h5>Recent Orders</h5>
                {orders.map((order) => (
                  <div
                    key={order.id}
                    className="d-flex justify-content-between py-3 border-bottom"
                  >
                    <div>
                      <strong>{order.product}</strong>
                      <div>{order.id}</div>
                    </div>
                    <div>{order.amount}</div>
                  </div>
                ))}
              </Card.Body>
            </Card>
          </>
        );

      case "profile":
        return (
          <Card className="border-0 shadow-sm">
              <Card.Body>
                <h4 className="mb-4">My Profile</h4>

                <Row>
                  {/* Full Name */}
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        placeholder="Enter Name"
                        value={`${formData.first_name}`}
                        readOnly
                      />
                    </Form.Group>
                  </Col>

                  {/* Email */}
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        placeholder="Enter Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* Phone */}
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        placeholder="Enter Phone"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* Birthday */}
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Birthday</Form.Label>
                      <Form.Control
                        type="date"
                        name="birthday"
                        value={formData.birthday}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* Anniversary */}
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Anniversary</Form.Label>
                      <Form.Control
                        type="date"
                        name="anniversary"
                        value={formData.anniversary}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Button variant="dark">
                  Save Changes
                </Button>
              </Card.Body>
         </Card>
        );

      case "orders":
        return (
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h4 className="mb-4">Order History</h4>

              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Product</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {orders.map((order) => (
                    <tr key={order.id}>
                      <td>{order.order_id}</td>
                      <td>{order.product_name}</td>
                      <td>{order.order_amount}</td>
                      <td>
                        <Badge
                          bg={
                            order.status === "Delivered"
                              ? "success"
                              : "warning"
                          }
                        >
                          {order.status}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        );

      case "wishlist":
        return (
          <>
            <h4 className="mb-4">Wishlist</h4>

            <Row className="g-4">
              {wishlist.map((item) => (
                <Col md={4} key={item.id}>
                  <Card className="border-0 shadow-sm">
                    <Card.Img src={item.image} />

                    <Card.Body>
                      <h6>{item.name}</h6>
                      <p>{item.price}</p>

                      <Button
                        variant="dark"
                        size="sm"
                      >
                        Add To Cart
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        );

      case "address":
        return (
          <>
            <div className="d-flex justify-content-between mb-4">
              <h4>Delivery Address</h4>

              <Button variant="dark">
                Add Address
              </Button>
            </div>

            <Card className="border-0 shadow-sm">
              <Card.Body>
                <Badge bg="secondary">Home</Badge>

                <h6 className="mt-3">
                 {session.first_name}
                </h6>

                <p>
                  New Delhi, India
                  <br />
                  110001
                  <br />
                  +91 9999999999
                </p>
                
              </Card.Body>
            </Card>
          </>
        );

      case "points":
        return (
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h4 style={{color:"red"}}>Loyalty Points</h4>

              <h1 className="my-4">
                1500 Points
              </h1>

              <ProgressBar
                now={75}
                className="mb-3"
              />

              <p>
                500 more points required
                for Platinum Membership.
              </p>
            </Card.Body>
          </Card>
        );

      case "refer":
        return (
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h4>Refer & Earn</h4>

              <p>
                Share your referral code
                and earn reward points.
              </p>

              <h5 className="bg-light p-3 rounded">
                REFER25
              </h5>
            </Card.Body>
          </Card>
        );

      case "recent":
        return (
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h4 style={{color:"black"}}>Recently Viewed</h4>

              <ul>
                <li>Diamond Ring</li>
                <li>Gold Pendant</li>
                <li>Bracelet</li>
              </ul>
            </Card.Body>
          </Card>
        );

      default:
        return null;
    }
  };



  return (
    <div
      style={{
        background: "#f7f7f7",
        minHeight: "100vh",
      }}
    >
      <div
        className="text-center py-4 bg-white border-bottom"
      >
        <h2
          style={{
            letterSpacing: "3px",
            fontWeight: 300,
          }}
        >
          MY ACCOUNT
        </h2>
      </div>

      <Container fluid className="py-5">
        <Row className="justify-content-center">

          {/* Sidebar */}

          <Col lg={3}>
            <Card
              className="border-0 shadow-sm rounded-4"
            >
              <Card.Body>

                <div className="text-center mb-4">
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      background: "#ddd",
                      borderRadius: "50%",
                      margin: "auto",
                    }}
                  />

                  <h6 className="mt-3">
                    {session.first_name +" "+ session.last_name}
                  </h6>
                </div>

                <Nav className="flex-column">

                  <Nav.Link
                    onClick={() =>
                      setActiveTab("dashboard")
                    }
                  >
                    Dashboard
                  </Nav.Link>

                  <Nav.Link
                    onClick={() =>
                      setActiveTab("profile")
                    }
                  >
                    My Profile
                  </Nav.Link>

                  <Nav.Link
                    onClick={() =>
                      setActiveTab("orders")
                    }
                  >
                    Order History
                  </Nav.Link>

                  <Nav.Link
                    onClick={() =>
                      setActiveTab("wishlist")
                    }
                  >
                    Wishlist
                  </Nav.Link>

                  <Nav.Link
                    onClick={() =>
                      setActiveTab("address")
                    }
                  >
                    Delivery Address
                  </Nav.Link>

                  <Nav.Link
                    onClick={() =>
                      setActiveTab("points")
                    }
                  >
                    Loyalty Points
                  </Nav.Link>

                  <Nav.Link
                    onClick={() =>
                      setActiveTab("refer")
                    }
                  >
                    Refer & Earn
                  </Nav.Link>

                  <Nav.Link
                    onClick={() =>
                      setActiveTab("recent")
                    }
                  >
                    Recently Viewed
                  </Nav.Link>

                </Nav>

              </Card.Body>
            </Card>
          </Col>

          {/* Right Content */}

          <Col lg={8}>
            {renderContent()}
          </Col>

        </Row>
      </Container>
    </div>
  );
};

export default AccountDashboard;